import React from "react"

const EmptyColumn = () => <div></div>

export default EmptyColumn
